import React from "react";
import classNames from "classnames/bind";
import styles from "./Performance.module.scss";

const cx = classNames.bind(styles);

export default function Performance({
  inputValue,
  handleChange,
  handleSubmit,
}) {
  return (
    <>
      <div className={cx("title_box")}>
        <p className={cx("title")}>매출</p>
        <button className={cx("performance_button")}>?</button>
        <div className={cx("modal_box")}>
          <img src="/images/performance.png" alt="performance" />
          <p className={cx("modal_text")}>빨간색 표시에 들어갈 내용 입니다.</p>
        </div>
      </div>
      <div className={cx("input_inner")}>
        <div className={cx("input_box")}>
          <label className={cx("label")}>연도</label>
          <input
            type="text"
            placeholder="연도"
            className={cx("input")}
            name="salesYear"
            value={inputValue?.salesYear || ""}
            onChange={handleChange}
          />
        </div>
        <div className={cx("input_box")}>
          <label className={cx("label")}>매출</label>
          <input
            type="text"
            placeholder="매출"
            className={cx("input")}
            name="salesNumber"
            value={inputValue?.salesNumber?.toLocaleString() || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={cx("title_box")}>
        <p className={cx("title")}>고객사</p>
        <button className={cx("performance_button")}>?</button>
        <div className={cx("modal_box")}>
          <img src="/images/performance.png" alt="performance" />
          <p className={cx("modal_text")}>빨간색 표시에 들어갈 내용 입니다.</p>
        </div>
      </div>
      <div className={cx("input_inner")}>
        <div className={cx("input_box")}>
          <label className={cx("label")}>연도</label>
          <input
            type="text"
            placeholder="연도"
            className={cx("input")}
            name="clientYear"
            value={inputValue?.clientYear || ""}
            onChange={handleChange}
          />
        </div>
        <div className={cx("input_box")}>
          <label className={cx("label")}>고객사 수</label>
          <input
            type="text"
            placeholder="고객사 수"
            className={cx("input")}
            name="clientNumber"
            value={inputValue?.clientNumber?.toLocaleString() || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={cx("button_box")}>
        <button className={cx("button")} onClick={handleSubmit}>
          저장 하기
        </button>
      </div>
    </>
  );
}
